import {ProfileQrCode, ProfileQrCodeDownload, ProfileQrCodeDownloadLogo} from "../../../components/qrcode/ProfileQrCode"
import { Navigate } from "react-router-dom"
import { Box } from "@mui/material"
import { useEffect } from "react"

const QrDownload = () => {

    const queryParameters = new URLSearchParams(window.location.search)
    const filename = queryParameters.get("filename") ?? ''
    const url = window.location.origin + "/profile/"+ filename

    useEffect(()=>{
        (async()=>{
            await downloadQRCode(filename)
            setTimeout(()=>{window.close()},1000)
        })()
    })

    if(!filename) return <Navigate to="/"/>

    const downloadQRCode = async (filename: string) => {
        const qrHtmlEl = document.getElementsByTagName("canvas")[0]
        if (!qrHtmlEl) throw new Error("<qr> not found in DOM")

        const pngUrl =  qrHtmlEl.toDataURL("image/png").replace('image/png', 'image/octet-stream')
        const downloadLink = document.createElement("a")
        downloadLink.href = pngUrl
        downloadLink.download = `${filename}.png`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    }

    return(
        <Box 
            display={"flex"} 
            justifyContent={"center"} 
            m="20px"
        >
            <Box
                bgcolor={"white"}
                id = {'qr-profile'}
                borderRadius={20}
            >
                <ProfileQrCodeDownloadLogo url={url}/>
            </Box>
        </Box>
    )
}

export default QrDownload;